var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_94",
    x: 11.9,
    y: 0.1,
    width: 30.1,
    height: 30,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_95",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SELECT",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_94)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_94-2",
    "data-name": "Pfad 94",
    className: "cls-1",
    d: "M14.2,24.1l-2.3-2.3L22.6,11.1,14.8,9,36,.1,27,21.3l-2-7.9Zm-.9-2.3.9.9L25.4,11.5l1.8,6.7L34.1,2,17.9,8.8l6.7,1.8Z",
    transform: "translate(3 3)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_95)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_95-2",
    "data-name": "Pfad 95",
    fill: "#f5f5f5",
    d: "M34,18.1A16,16,0,1,1,18,2h.1V0H18A18,18,0,1,0,36,18.1Z",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.68e7d0fa3f46410c716b9a29cbe9728f.svg";
export { ForwardRef as ReactComponent };